import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContentLayoutComponent } from './layouts/content-layout/content-layout.component';
import { FullLayoutComponent } from './layouts/full-layout/full-layout.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { TapToTopComponent } from './components/tap-to-top/tap-to-top.component';
import { LoaderComponent } from './components/loader/loader.component';
import { RouterModule } from '@angular/router';
import { NgbDropdown, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NotificationSidebarComponent } from './components/notification-sidebar/notification-sidebar.component';
import { FullscreenDirective } from './directives/fullscreen.directive';
import { NgSelectModule } from '@ng-select/ng-select';
import { HighlightModule, HIGHLIGHT_OPTIONS } from 'ngx-highlightjs';
import { HoriHeaderComponent } from './components-horizontal/hori-header/hori-header.component';
import { HorizontalMenuComponent } from './components-horizontal/horizontal-menu/horizontal-menu.component';
import { HoriFullLayoutComponent } from './layouts-horizontal/hori-full-layout/hori-full-layout.component';
import { MaterialModule } from './material.module';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { DpDatePickerModule } from 'ng2-date-picker';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { NgxMatDatetimePickerModule, NgxMatNativeDateModule, NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { DatePickerModule } from '../components/advanced-ui/datetime-range-picker/datetime-range-picker.module';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { ModalComponent, NgbdModal2Content } from './components/modal/modal.component';
import { ActionButtonsComponent } from './components/action-buttons/action-buttons.component';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { AgGridModule } from 'ag-grid-angular';
import { ObjectValues } from './components/pipes/object.values.pipe';
import { NgbProgressbarConfig, NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';
import { ProgressBarComponent } from '../components/actionability/livewalk-test/progress-bar/progress.bar/progress.bar.component';
import { SpeedDialModule } from 'primeng/speeddial';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ObjectKeys } from './components/pipes/object.keys.pipe';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'
import { BatteryLevelComponentComponent } from '../components/visibility/assets/device-battery-level/battery-level-component/battery-level-component.component';
import { ProgressSpinnerModule }
  from "primeng/progressspinner";
  import { ThreeLedsComponent } from './components/three-leds/three-leds.component';
import { RippleModule } from "primeng/ripple";
import { TimeAgoPipe } from '../pipes/timeago.pipe';
import { NgApexchartsModule } from 'ng-apexcharts';
import {MatIconModule} from '@angular/material/icon';
import {MatTableModule} from '@angular/material/table';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ValidArrayPipe } from './components/pipes/valid.array.pipe';



// import { DemoNgZorroAntdModule } from '../ng-zorro-antd.module';
@NgModule({
  declarations: [ContentLayoutComponent, ProgressBarComponent, TimeAgoPipe,ThreeLedsComponent,
    FullLayoutComponent, ModalComponent,
    HeaderComponent, FooterComponent, SidebarComponent, TapToTopComponent, ActionButtonsComponent,
    LoaderComponent, NotificationSidebarComponent, FullscreenDirective, HoriHeaderComponent, HorizontalMenuComponent,
    HoriFullLayoutComponent, NgbdModal2Content, ObjectValues, ObjectKeys,BatteryLevelComponentComponent,ValidArrayPipe],
  imports: [SpeedDialModule, FontAwesomeModule, NgbTooltipModule,
    NgbProgressbarModule,MatIconModule,MatTableModule,TabsModule,
    AgGridModule,
    CommonModule,
    RouterModule,
    DpDatePickerModule,
    NgxDaterangepickerMd.forRoot(),
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    NgxMatNativeDateModule,
    MatFormFieldModule,
    NgApexchartsModule,
    DatePickerModule,
    AngularMultiSelectModule,
    NgxSliderModule, ProgressSpinnerModule, RippleModule,
    NgbModule, NgSelectModule, FormsModule,
    ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'never' }), CarouselModule,
    ToastrModule.forRoot(
      {
        timeOut: 2000
      }
    ),
  ],
  exports: [SpeedDialModule, FontAwesomeModule, NgbTooltipModule,ThreeLedsComponent,
    NgbProgressbarModule, ProgressBarComponent, AngularMultiSelectModule,
    AgGridModule,
    LoaderComponent, ModalComponent,
    ContentLayoutComponent, FullLayoutComponent, HoriFullLayoutComponent,
    FooterComponent, SidebarComponent,
    TapToTopComponent,
    NotificationSidebarComponent, FullscreenDirective,
    HoriHeaderComponent, HorizontalMenuComponent,
    MaterialModule, NgbdModal2Content, ObjectValues, ObjectKeys, ProgressSpinnerModule, RippleModule,
    BatteryLevelComponentComponent,NgApexchartsModule,MatIconModule,MatTableModule,ValidArrayPipe
  ],
  providers: [ NgbDropdown,
    {
      provide: HIGHLIGHT_OPTIONS,
      useValue: {
        fullLibraryLoader: () => import('highlight.js'),
      }
    }, ToastrService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule { }
